import { FC, SVGProps } from 'react'

import { cn } from '@/shared/lib'

import Camera from './asset/camera.svg'
import ResetBold from './asset/reset-bold.svg'
import Reset from './asset/reset.svg'

export { SpriteSheet } from './sprite-sheet'

export type Props = {
  name: string
  size?: number | string
}

const ICON: { [key: string]: FC<SVGProps<SVGSVGElement>> } = {
  reset: Reset,
  'reset-bold': ResetBold,
  camera: Camera,
}

export const Icon = (props: SVGProps<SVGSVGElement> & Props) => {
  const { name, size = '100%', strokeWidth = 1, className, ...rest } = props

  if (ICON[name]) {
    const IconComponent = ICON[name]

    return (
      <IconComponent
        width={size}
        height={size}
        className={cn('shrink-0', className)}
        strokeWidth={strokeWidth}
        {...props}
      />
    )
  }

  return (
    <svg
      width={size}
      height={size}
      className={cn('shrink-0', className)}
      strokeWidth={strokeWidth}
      {...rest}
    >
      <use href={`#${name}`} />
    </svg>
  )
}
